import { gql } from '@apollo/client'

export const PATIENT_CLINICAL_TESTS = gql`
  query PATIENT_CLINICAL_TESTS($id: ID!, $orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String, $appointment: ID) {
    patientClinicalTests(
      patient: $id
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      appointment: $appointment
    ) {
      id
      description
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      signed
      signature
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      signedAt
      signedBy {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      createdAt
      updatedAt
    }
  }
`
export const PATIENT_TOTAL_CLINICAL_TESTS = gql`
  query PATIENT_TOTAL_CLINICAL_TESTS($id: ID!, $searchTerm: String, $appointment: ID) {
    patientTotalClinicalTests(patient: $id, searchTerm: $searchTerm, appointment: $appointment)
  }
`
export const PATIENT_CLINICAL_TEST = gql`
  query PATIENT_CLINICAL_TEST($clinicalTest: ID!) {
    patientClinicalTest(clinicalTest: $clinicalTest) {
      id
      description
      values {
        id
        status
        details
        options
        checkboxes
        clinicalItem {
          id
          type
        }
      }
      signed
      signature
      signedAt
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      signedBy {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const PATIENT_DETAILS = gql`
  query PATIENT_DETAILS($patient: ID!) {
    patientDetails(patient: $patient) {
      id
      firstName
      lastName
      type
      patientId
      referenceId
      phoneNumber
      hasValidNumber
      hasMedicalAlerts
      phoneNumber2
      gender
      marital
      formsSigned
      email
      country
      allowAccess {
        id
        name
      }
      firstPaymentDate
      nationalId
      pending
      insuranceCompany {
        id
        name
        number
        forcePolicySelect
        taxPercent
        nphiesCode
        tpaNphiesCode
      }
      primaryFamily {
        id
        relation
        secondary {
          id
          firstName
          lastName
        }
      }
      points {
        id
        remaining
        total
        expired
        firstToExpire
        used
      }
      activeAppointment {
        id
        status
        start
        room
        type
      }
      lastAppointment {
        id
        status
        start
        room
        type
      }
      prevAppointment {
        id
        status
        start
        room
        type
      }
      insured
      insuranceLimit
      insuranceUnlimited
      approvalRequired
      insurancePercentage
      insuranceEndDate
      insuranceStartMonth
      balance
      totalInsurance
      totalPaid
      totalRemaining
      disabled
      details
      phoneNumber
      firstNameE
      lastNameE
      phoneNumberE
      phoneNumber2E
      referralDetails
      nationality
      addressE
      relationE
      address
      title
      birthDate
      birthDay
      longitude
      latitude
      job
      patientTags {
        id
        name
        color
        hasNextTags
      }
      referralSource {
        id
        name
        color
        forPatients
        forUsers
        forceSubtype
      }
      referralSubSource {
        id
        name
        color
      }
      mixedDentition
      images
      tax
      insuranceNumber
      insuranceGroup
      insuranceCRT
      signed
      signedAt
      signature
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      remainingPackage
      witnessSignAt
      signedBy {
        id
        name
      }
      onlineConversation {
        id
      }
      lead {
        id
        referenceId
        score
        due
        dealSize
        createdAt
        stagedAt
        lastInteraction
        journeyedAt
        assignedTo {
          id
          name
        }
        stage {
          id
          name
        }
        rejectReason {
          id
          name
        }
        currentView {
          id
          name
        }
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
        nphiesCode
      }
      priceList {
        id
        name
        syncTo
        difference
        percentage
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      customFields {
        id
        value
        field {
          id
        }
      }
      referralUser {
        id
        name
      }
      referralPatient {
        id
        firstName
        lastName
      }
      medicalUpdater {
        id
        name
      }
      medicalUpdatedAt
      medicalHistory {
        id
        status
        details
        options
        checkboxes
        medicalItemId
      }
      hasPendingMedical
      identifierType
      maxInsuranceLimit
      lastPaymentDate
      dailyAmountPaid
      dailyInsurancePaid
      insurancePolicy {
        id
        holderName
        policyNumber
      }
      policyClass {
        id
        name
        maxLimit
        insuranceLimit
        insuranceUnlimited
        insurancePercentage
        approvalRequired
      }
      currentEligibility {
        id
        status
        checkedAt
        responseDate
        insuranceCompanyId
      }
      dhsEligibilityChecks {
        id
        status
        checkedAt
        responseDate
      }
    }
  }
`

export const PATIENT_MEDICAL_HISTORY = gql`
  query PATIENT_MEDICAL_HISTORY($patient: ID!) {
    patientMedicalHistory(patient: $patient) {
      id
      medicalHistory {
        id
        status
        details
        options
        checkboxes
        medicalItemId
      }
    }
  }
`
export const PENDING_PATIENT_MEDICAL = gql`
  query PENDING_PATIENT_MEDICAL($patient: ID!) {
    pendingPatientMedical(patient: $patient) {
      id
      pendingMedical {
        id
        status
        details
        options
        checkboxes
        medicalItemId
      }
    }
  }
`
export const TOTAL_PATIENTS = gql`
  query TOTAL_PATIENTS(
    $searchTerm: String
    $disabled: Boolean
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $priceList: ID
    $branchId: ID
    $filters: Filter
    $doctor: ID
    $patientLink: ID
    $userId: ID
    $insurancePolicy: ID
    $policyClass: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalPatients(
      searchTerm: $searchTerm
      disabled: $disabled
      branchId: $branchId
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      priceList: $priceList
      filters: $filters
      doctor: $doctor
      patientLink: $patientLink
      userId: $userId
      insurancePolicy: $insurancePolicy
      policyClass: $policyClass
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`
export const GET_PATIENTS = gql`
  query GET_PATIENTS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $disabled: Boolean
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $priceList: ID
    $branchId: ID
    $filters: Filter
    $doctor: ID
    $patientLink: ID
    $userId: ID
    $insurancePolicy: ID
    $policyClass: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    patients(
      orderBy: $orderBy
      branchId: $branchId
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      disabled: $disabled
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      priceList: $priceList
      filters: $filters
      doctor: $doctor
      patientLink: $patientLink
      userId: $userId
      insurancePolicy: $insurancePolicy
      policyClass: $policyClass
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      firstName
      lastName
      patientId
      referenceId
      phoneNumber
      hasValidNumber
      phoneNumber2
      gender
      marital
      email
      insuranceCompany {
        id
        name
      }
      points {
        id
        remaining
        firstToExpire
      }
      tax
      insuranceNumber
      insuranceGroup
      insuranceCRT
      insured
      insuranceLimit
      insuranceUnlimited
      approvalRequired
      insurancePercentage
      insuranceEndDate
      insuranceStartMonth
      disabled
      pending
      details
      phoneNumber
      firstNameE
      lastNameE
      phoneNumberE
      phoneNumber2E
      referralDetails
      nationality
      addressE
      relationE
      country
      address
      longitude
      latitude
      title
      balance
      totalInsurance
      totalPaid
      totalRemaining
      birthDate
      birthDay
      job
      patientTags {
        id
        name
        color
        hasNextTags
      }
      referralSource {
        id
        name
        color
        forPatients
        forUsers
        forceSubtype
      }
      referralSubSource {
        id
        name
        color
      }
      lastPaymentDate
      dailyAmountPaid
      dailyInsurancePaid
      nationalId
      images
      firstPaymentDate
      patientDueDate {
        id
        dueDate
      }
      activeAppointment {
        id
        status
        start
        room
      }
      lastAppointment {
        id
        status
        start
        room
      }
      prevAppointment {
        id
        status
        start
        room
      }
      hasPendingMedical
      remainingPackage
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      priceList {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      referralUser {
        id
        name
      }
      referralPatient {
        id
        firstName
        lastName
      }
    }
  }
`

export const TOTAL_COMMUNICATIONS = gql`
  query TOTAL_COMMUNICATIONS($id: ID, $searchTerm: String, $rangeDate: [DateTime!]!, $filters: Filter, $lab: ID) {
    totalCommunications(id: $id, searchTerm: $searchTerm, rangeDate: $rangeDate, filters: $filters, lab: $lab)
  }
`
export const COMMUNICATIONS_INFO = gql`
  query COMMUNICATIONS_INFO($id: ID, $searchTerm: String, $rangeDate: [DateTime!]!, $filters: Filter, $lab: ID) {
    communicationsInfo(id: $id, searchTerm: $searchTerm, rangeDate: $rangeDate, filters: $filters, lab: $lab) {
      id
      status
      length
      attempts
    }
  }
`
export const GET_COMMUNICATIONS = gql`
  query GET_COMMUNICATIONS(
    $id: ID
    $searchTerm: String
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $lab: ID
  ) {
    communications(
      id: $id
      searchTerm: $searchTerm
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      lab: $lab
    ) {
      id
      content
      status
      length
      to
      pending
      sentAt
      types
      company {
        id
        companyName
      }
      createdBy {
        id
        name
      }
      receivedPatient {
        id
        firstName
        lastName
        phoneNumber
      }
      receivedUser {
        id
        name
        phoneNumber
      }
      receivedLab {
        id
        name
        number
      }
      createdAt
    }
  }
`
export const TOTAL_PATIENT_REMINDERS = gql`
  query TOTAL_PATIENT_REMINDERS($searchTerm: String, $filters: Filter, $procedure: ID) {
    totalPatientReminders(searchTerm: $searchTerm, filters: $filters, procedure: $procedure)
  }
`
export const GET_PATIENT_REMINDERS = gql`
  query GET_PATIENT_REMINDERS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $filters: Filter
    $procedure: ID
  ) {
    patientReminders(
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      filters: $filters
      procedure: $procedure
    ) {
      id
      name
      every
      interval
      info
      automatic
      at
      details
      whatsAppTemplate
      types
      template {
        id
        status
        whatsAppID
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const PATIENT_REMINDERS_DETAILS = gql`
  query PATIENT_REMINDERS_DETAILS($patientReminder: ID!) {
    patientReminderDetails(patientReminder: $patientReminder) {
      id
      name
      every
      interval
      info
      automatic
      at
      details
      whatsAppTemplate
      types
      template {
        id
        status
        whatsAppID
      }
      procedures {
        id
        name
        code
        group {
          id
          name
        }
      }
      procedureSteps {
        id
        name
        procedure {
          id
          name
          code
          group {
            id
            name
          }
        }
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const TOTAL_ACTIVE_REMINDERS = gql`
  query TOTAL_ACTIVE_REMINDERS(
    $rangeDate: [DateTime!]!
    $branchId: ID
    $id: ID
    $filters: Filter
    $operation: ID
    $operationStep: ID
    $appointment: ID
  ) {
    totalActiveReminders(
      rangeDate: $rangeDate
      branchId: $branchId
      patient: $id
      filters: $filters
      operation: $operation
      operationStep: $operationStep
      appointment: $appointment
    )
  }
`
export const GET_ACTIVE_REMINDERS = gql`
  query GET_ACTIVE_REMINDERS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $branchId: ID
    $id: ID
    $filters: Filter
    $operation: ID
    $operationStep: ID
    $appointment: ID
  ) {
    getActiveReminders(
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      branchId: $branchId
      patient: $id
      filters: $filters
      operation: $operation
      operationStep: $operationStep
      appointment: $appointment
    ) {
      id
      createdAt
      date
      remindedAt
      name
      details
      at
      automatic
      types
      createdBy {
        id
        name
      }
      branch {
        id
        name
      }
      operation {
        id
        createdAt
        name
        code
      }
      operationStep {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        hasValidNumber
      }
      appointment {
        id
        start
        status
        room
      }
      reminder {
        id
        name
        automatic
        details
        info
        at
      }
    }
  }
`
export const TOTAL_PATIENT_FILES = gql`
  query TOTAL_PATIENT_FILES(
    $forUser: Boolean!
    $id: ID
    $insuranceCompanies: [ID]
    $supplier: ID
    $lab: ID
    $invoice: ID
    $expense: ID
    $income: ID
    $inventory: ID
    $treasury: ID
    $counter: ID
    $inventoryItem: ID
    $inventoryOrder: ID
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $appointment: ID
    $operation: ID
  ) {
    totalPatientFiles(
      forUser: $forUser
      id: $id
      insuranceCompanies: $insuranceCompanies
      supplier: $supplier
      lab: $lab
      invoice: $invoice
      expense: $expense
      income: $income
      inventory: $inventory
      treasury: $treasury
      counter: $counter
      inventoryItem: $inventoryItem
      inventoryOrder: $inventoryOrder
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      appointment: $appointment
      operation: $operation
    )
  }
`
export const GET_PATIENT_FILES = gql`
  query GET_PATIENT_FILES(
    $forUser: Boolean!
    $id: ID
    $insuranceCompanies: [ID]
    $supplier: ID
    $lab: ID
    $invoice: ID
    $expense: ID
    $income: ID
    $inventory: ID
    $treasury: ID
    $counter: ID
    $inventoryItem: ID
    $inventoryOrder: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $filters: Filter
    $appointment: ID
    $operation: ID
  ) {
    patientFiles(
      forUser: $forUser
      id: $id
      insuranceCompanies: $insuranceCompanies
      supplier: $supplier
      lab: $lab
      invoice: $invoice
      expense: $expense
      income: $income
      inventory: $inventory
      treasury: $treasury
      counter: $counter
      inventoryItem: $inventoryItem
      inventoryOrder: $inventoryOrder
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      filters: $filters
      appointment: $appointment
      operation: $operation
    ) {
      id
      name
      url
      size
      type
      order
      inventoryOrderId
      inventoryItemId
      patientId
      userId
      insuranceCompanyId
      supplierId
      labId
      invoiceId
      expenseId
      incomeId
      treasuryId
      counterId
      appointment {
        id
        start
        status
        room
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const GET_PATIENT_GALLERY = gql`
  query GET_PATIENT_GALLERY($patient: ID!) {
    patientGallery(patient: $patient) {
      files {
        id
        name
        url
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
        createdAt
        updatedAt
      }
      folders {
        id
        name
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
        totalItems
        createdAt
        updatedAt
      }
    }
  }
`
export const PATIENT_FOLDER_DETAILS = gql`
  query PATIENT_FOLDER_DETAILS($folder: ID!) {
    patientFolderDetails(folder: $folder) {
      id
      name
      files {
        id
        name
        url
        createdBy {
          id
          name
        }
        createdAt
      }
      folders {
        id
        name
        createdBy {
          id
          name
        }
        createdAt
        totalItems
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const TOTAL_PATIENT_XRAYS = gql`
  query TOTAL_PATIENT_XRAYS($id: ID!, $searchTerm: String, $rangeDate: [DateTime!]!, $appointment: ID, $operation: ID) {
    totalPatientXrays(
      patient: $id
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      appointment: $appointment
      operation: $operation
    )
  }
`
export const GET_PATIENT_XRAYS = gql`
  query GET_PATIENT_XRAYS(
    $id: ID!
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $rangeDate: [DateTime!]!
    $appointment: ID
    $operation: ID
  ) {
    patientXrays(
      patient: $id
      orderBy: $orderBy
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      rangeDate: $rangeDate
      appointment: $appointment
      operation: $operation
    ) {
      id
      name
      details
      type
      files {
        id
        name
        url
        order
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      createdAt
      updatedAt
    }
  }
`
export const GET_PATIENT_XRAY = gql`
  query GET_PATIENT_XRAY($xray: ID!) {
    patientXray(xray: $xray) {
      id
      name
      details
      patientId
      operationId
      appointment {
        id
        start
        status
        room
      }
      type
      files {
        id
        name
        url
        order
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const NEW_PATIENT_ID = gql`
  query NEW_PATIENT_ID {
    newPatientId
  }
`
export const NEW_INVOICE_ID = gql`
  query NEW_INVOICE_ID {
    newInvoiceId
  }
`
export const GET_PATIENT_OPERATIONS = gql`
  query GET_PATIENT_OPERATIONS($patient: ID!, $chart: ChartTypes) {
    getPatientOperations(patient: $patient, chart: $chart) {
      id
      name
      code
      price
      status
      child
      approved
      cost
      diagnosis
      start
      end
      priceDiff
      forOperator
      details
      remaining
      actionsCreated
      hasSteps
      taxApplied
      preAuth
      allowMaxLimit
      initialDiscount
      inventoryStatus
      dhsApproval {
        id
        status
        approvalNumber
        manualUpdatedBy {
          id
          name
        }
      }
      priceList {
        id
        name
        syncTo
      }
      approvalRequired
      insuranceDiscount
      insuranceValue
      expires
      insuranceCompany {
        id
        name
      }
      procedure {
        id
        name
        code
        toothEffect
        insuranceDiscount
        openLab
        ageGroup
        requireCounter
        requireOperationCounter
        remaining
      }
      condition {
        id
        name
        code
        toothEffect
      }
      tooth
      missing
      toothPart
      amount
      discount
      tax
      appointment {
        id
        status
        start
        diagnosticFee
        createdBy {
          id
          name
        }
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
        nphiesCode
      }
      invoice {
        id
        paid
        subtotal
        paidInFull
        pendingPayment
        discount
        tax
        invoiceId
        referenceId
        diagnosticFee
        insurance
        total
        taxPercent
        discountPercent
        pendingPaymentPercent
        balance
        details
        eInvoiceStatus
        insuranceEInvoiceStatus
        lastEInvoiceReport {
          id
          status
          submissionTime
          data {
            id
            qrCode
          }
        }
        insuranceLastEInvoiceReport {
          id
          status
          submissionTime
          data {
            id
            qrCode
          }
        }
      }
      dhsApproval {
        id
        status
        approvalNumber
        requestPayload
        responsePayload
        canceledAt
        canceledBy {
          id
          name
        }
        createdAt
        updatedAt
      }
      files {
        id
        name
        url
        type
        size
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
    }
  }
`
export const PATIENT_PERIO_EXAM = gql`
  query PATIENT_PERIO_EXAM($patient: ID!) {
    patientPerioExam(patient: $patient) {
      id
      teethData {
        id
        tooth
        mobility
        furcation
        plaque
        bleeding
        margin
        depth
        buccal
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`
export const GET_PATIENT_NOTES = gql`
  query GET_PATIENT_NOTES($patient: ID!, $appointment: ID, $chart: ChartTypes) {
    getPatientNotes(patient: $patient, appointment: $appointment, chart: $chart) {
      id
      child
      tooth
      details
      url
      procedureId
      appointment {
        id
        status
        start
        room
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const NOTE_DETAILS = gql`
  query NOTE_DETAILS($note: ID!) {
    noteDetails(note: $note) {
      id
      child
      tooth
      details
      url
      starred
      seen
      appointment {
        id
        start
        status
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const GET_PATIENT_CANALS = gql`
  query GET_PATIENT_CANALS($patient: ID!, $appointment: ID, $chart: ChartTypes) {
    getPatientCanals(patient: $patient, appointment: $appointment, chart: $chart) {
      id
      child
      tooth
      MB1
      MB2
      DB
      P
      L
      MB
      ML
      D
      B
      DL
      referencePoints
      extraFields
      procedureId
      appointment {
        id
        status
        start
      }
      doctor {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const CANAL_DETAILS = gql`
  query CANAL_DETAILS($canal: ID!) {
    canalDetails(canal: $canal) {
      id
      child
      tooth
      MB1
      MB2
      DB
      P
      L
      MB
      ML
      D
      B
      DL
      chart
      referencePoints
      extraFields
      appointment {
        id
        start
        status
      }
      doctor {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      createdAt
    }
  }
`

export const OPERATION_DETAILS = gql`
  query OPERATION_DETAILS($operation: ID!) {
    operationDetails(operation: $operation) {
      id
      name
      code
      price
      status
      total
      child
      diagnosis
      updated
      cost
      forOperator
      preAuth
      priceDiff
      originalPrice
      completedPercent
      paid
      tax
      discount
      paidInFull
      paidAt
      end
      start
      approved
      approvalRequired
      details
      actionsCreated
      inventoryStatus
      paid
      remaining
      remainingCost
      paidInFull
      chart
      expires
      dhsApproval {
        id
        status
        approvalNumber
        manualUpdatedBy {
          id
          name
        }
      }
      insuranceCompany {
        id
        name
      }
      insurancePolicy {
        id
        holderName
        policyNumber
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      steps {
        id
        name
        status
        isAutomatic
        details
        order
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
        mixedDentition
      }
      procedure {
        id
        name
        code
        remaining
        requireOperationCounter
      }
      condition {
        id
        name
        code
      }
      tooth
      missing
      toothPart
      amount
      invoice {
        id
        paid
        subtotal
        paidInFull
        pendingPayment
        discount
        tax
        diagnosticFee
        insurance
        total
        taxPercent
        discountPercent
        pendingPaymentPercent
        details
        invoiceId
        referenceId
        eInvoiceStatus
        insuranceEInvoiceStatus
        claimLocked
        claimId
        claim {
          id
          name
          status
        }
      }
      appointment {
        id
        start
        status
        room
      }
      updateAppointment {
        id
        start
        status
        room
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
        nphiesCode
      }
      priceList {
        id
        name
        syncTo
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const OPERATION_STEP_DETAILS = gql`
  query OPERATION_STEP_DETAILS($operationStep: ID!) {
    operationStepDetails(operationStep: $operationStep) {
      id
      name
      details
      end
      start
      paidAt
      order
      total
      paid
      paidInFull
      actionsCreated
      inventoryStatus
      forOperator
      forLab
      discount
      tax
      isAutomatic
      status
      package
      salaryAdjustment {
        id
      }
      counterLog {
        id
      }
      operation {
        id
        name
        code
        tooth
        child
        approvalRequired
        approved
        actionsCreated
        invoice {
          id
        }
        procedure {
          id
          remaining
          requireOperationCounter
        }
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
      }
      procedureStep {
        id
        createForm
        createLabOrder
        createPrescription
        freeForms {
          id
          name
          signRequired
        }
        labItems {
          id
          name
        }
        prescriptions {
          id
          name
        }
      }
      formInstances {
        id
        name
        signed
        signRequired
      }
      appointment {
        id
        start
        status
        room
      }
      updateAppointment {
        id
        start
        status
        room
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const CREATED_OPERATIONS = gql`
  query CREATED_OPERATIONS(
    $branchId: ID
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $doctor: ID
    $patient: ID
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $chart: ChartTypes
    $alertBeforeOperations: Int
    $procedure: ID
    $procedureGroup: ID
    $globalCondition: ID
    $forAppointmentUpdated: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    createdOperations(
      branchId: $branchId
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      doctor: $doctor
      patient: $patient
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      chart: $chart
      alertBeforeOperations: $alertBeforeOperations
      procedure: $procedure
      procedureGroup: $procedureGroup
      globalCondition: $globalCondition
      forAppointmentUpdated: $forAppointmentUpdated
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      name
      code
      price
      status
      total
      child
      updated
      cost
      tax
      priceDiff
      originalPrice
      discount
      taxApplied
      forOperator
      diagnosis
      approved
      preAuth
      inventoryStatus
      approvalRequired
      details
      paid
      chart
      paidInFull
      expires
      remaining
      remainingCost
      dhsApproval {
        id
        status
        approvalNumber
        manualUpdatedBy {
          id
          name
        }
      }
      insuranceCompany {
        id
        name
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
        referralDetails
        patientTags {
          id
          name
          color
          hasNextTags
        }
        createdAt
        nationalId
      }
      procedure {
        id
        name
        code
      }
      condition {
        id
        name
        code
      }
      tooth
      missing
      toothPart
      amount
      invoice {
        id
        paid
        subtotal
        paidInFull
        pendingPayment
        discount
        tax
        diagnosticFee
        insurance
        total
        taxPercent
        discountPercent
        pendingPaymentPercent
        details
        invoiceId
        referenceId
        eInvoiceStatus
        insuranceEInvoiceStatus
      }
      appointment {
        id
        start
        status
        room
      }
      updateAppointment {
        id
        start
        status
        room
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
        nphiesCode
      }
      priceList {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const TOTAL_CREATED_OPERATIONS = gql`
  query TOTAL_CREATED_OPERATIONS(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $doctor: ID
    $patient: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $chart: ChartTypes
    $alertBeforeOperations: Int
    $procedure: ID
    $procedureGroup: ID
    $globalCondition: ID
    $forAppointmentUpdated: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalCreatedOperations(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      doctor: $doctor
      patient: $patient
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      chart: $chart
      alertBeforeOperations: $alertBeforeOperations
      procedure: $procedure
      procedureGroup: $procedureGroup
      globalCondition: $globalCondition
      forAppointmentUpdated: $forAppointmentUpdated
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`

export const CREATED_OPERATION_STEPS = gql`
  query CREATED_OPERATION_STEPS(
    $branchId: ID
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $doctor: ID
    $patient: ID
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $operation: ID
    $chart: ChartTypes
    $procedure: ID
    $procedureGroup: ID
    $forAppointmentUpdated: Boolean
  ) {
    createdOperationSteps(
      branchId: $branchId
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      doctor: $doctor
      patient: $patient
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      operation: $operation
      chart: $chart
      procedure: $procedure
      procedureGroup: $procedureGroup
      forAppointmentUpdated: $forAppointmentUpdated
    ) {
      id
      name
      status
      details
      end
      start
      paidAt
      order
      total
      paid
      chart
      paidInFull
      actionsCreated
      inventoryStatus
      forOperator
      forLab
      discount
      tax
      package
      operation {
        id
        name
        code
        approvalRequired
        approved
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        invoice {
          id
        }
      }
      salaryAdjustment {
        id
      }
      procedure {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
        referralDetails
        patientTags {
          id
          name
          color
          hasNextTags
        }
      }
      appointment {
        id
        start
        status
        room
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`

export const OPERATION_STEPS = gql`
  query OPERATION_STEPS($operation: ID!) {
    operationSteps(operation: $operation) {
      id
      name
      status
      details
      order
      inventoryStatus
      isAutomatic
      end
      counterLog {
        id
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      createdBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`
export const TOTAL_CREATED_OPERATION_STEPS = gql`
  query TOTAL_CREATED_OPERATION_STEPS(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $doctor: ID
    $patient: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $operation: ID
    $chart: ChartTypes
    $procedure: ID
    $procedureGroup: ID
    $forAppointmentUpdated: Boolean
  ) {
    totalCreatedOperationSteps(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      doctor: $doctor
      patient: $patient
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      operation: $operation
      chart: $chart
      procedure: $procedure
      procedureGroup: $procedureGroup
      forAppointmentUpdated: $forAppointmentUpdated
    )
  }
`
export const INVOICES = gql`
  query INVOICES(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    invoices(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      filters: $filters
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        title
        nationalId
        insuranceNumber
        insuranceGroup
        insuranceCRT
        patientTags {
          id
          name
          color
          hasNextTags
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
        createdAt
        insuranceCompany {
          id
          name
        }
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      salaryAdjustment {
        id
      }
      chart
      total
      tax
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      paid
      paidInFull
      referenceId
      invoiceId
      details
      preAuth
      operationInsurance
      released
      releasedAt
      balanceInvoice
      signed
      signedAt
      signature
      signedBy {
        id
        name
      }
      releasedBy {
        id
        name
      }
      users {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      createAppointment {
        id
        start
        status
        room
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      claimId
      claim {
        id
        name
        status
      }
      eInvoiceStatus
      status
      needsReReport
      insuranceEInvoiceStatus
      lastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
      insuranceLastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
    }
  }
`

export const DASHBOARD_INVOICES = gql`
  query DASHBOARD_INVOICES(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    dashboardInvoices(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      filters: $filters
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      patient {
        id
        firstName
        lastName
        birthDate
        patientId
        title
        referenceId
        phoneNumber
        nationalId
      }
      total
      tax
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      paid
      paidInFull
      referenceId
      invoiceId
      details
      operationInsurance
      released
      balanceInvoice
      createdAt
      createdBy {
        id
        name
      }
      eInvoiceStatus
      status
      needsReReport
      insuranceEInvoiceStatus
      lastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
      insuranceLastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
    }
  }
`

export const INVOICES_FOR_PRINT = gql`
  query INVOICES_FOR_PRINT(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    invoicesForPrint(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      filters: $filters
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        identifierType
        referenceId
        phoneNumber
        gender
        nationality
        insuranceNumber
        insuranceGroup
        insuranceCRT
        nationalId
        referralDetails
        patientTags {
          id
          name
          color
          hasNextTags
        }
        insuranceLimit
        insurancePercentage
        firstPaymentDate
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
        createdAt
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      operations {
        id
        name
        code
        price
        details
        amount
        tooth
        child
        discount
        insurance
        diagnosis
        tax
        total
        doctor {
          id
          name
          medicalNumber
        }
        files {
          id
          url
        }
      }
      insuranceCompany {
        id
        name
      }
      createAppointment {
        id
        start
        status
        room
      }
      insurancePolicy {
        id
        holderName
        policyNumber
      }
      policyClass {
        id
        name
      }
      total
      tax
      chart
      taxPercent
      discount
      discountPercent
      diagnosticFee
      dfDiscount
      patientPart
      patientTaxPercent
      insuranceTaxPercent
      dfInsurance
      dfTax
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      paid
      paidInFull
      referenceId
      invoiceId
      details
      preAuth
      operationInsurance
      released
      releasedAt
      balanceInvoice
      signed
      signedAt
      signature
      signedBy {
        id
        name
      }
      releasedBy {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
        medicalNumber
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const INVOICE_DETAILS = gql`
  query INVOICE_DETAILS($invoice: ID!, $token: String) {
    invoiceDetails(invoice: $invoice, token: $token) {
      id
      preAuth
      patientTaxPercent
      insuranceTaxPercent
      dfDiscountPercent
      dfInsurancePercent
      dfTaxApplied
      patientPart
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        title
        tax
        country
        state
        gender
        area
        insuranceNumber
        insuranceGroup
        insuranceCRT
        nationalId
        nationality
        insuranceCompany {
          id
          name
          taxPercent
        }
        policyClass {
          id
          name
          maxLimit
          insuranceLimit
          insuranceUnlimited
          insurancePercentage
          approvalRequired
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
        dailyInsurancePaid
        dailyAmountPaid
        lastPaymentDate
        maxInsuranceLimit
        points {
          id
          remaining
          firstToExpire
        }
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      total
      tax
      dfDiscount
      dfInsurance
      dfTax
      chart
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      subtotal
      pointsDiscount
      pointsValue
      pendingPayment
      pendingPaymentPercent
      paid
      invoiceId
      referenceId
      paidInFull
      details
      operationInsurance
      released
      releasedAt
      balanceInvoice
      signed
      signedAt
      signature
      insurancePolicy {
        id
        policyNumber
        holderName
      }
      policyClass {
        id
        name
      }
      insuranceCompany {
        id
        name
      }
      salaryAdjustment {
        id
      }
      signedBy {
        id
        name
      }
      releasedBy {
        id
        name
      }
      payments {
        id
        amount
        type
        other
        claimed
        details
        refunded
        refundedAt
        signed
        signedAt
        signature
        signedBy {
          id
          name
        }
        refundedBy {
          id
          name
        }
        insuranceCompany {
          id
          name
        }
        transaction {
          treasury {
            id
            publicName
          }
        }
        patientPointsTxs {
          id
        }
        refPatientPointsTxs {
          id
        }
        balance
        createdAt
        amount
        images
        branch {
          id
          name
        }
        doctor {
          id
          name
        }
        createdBy {
          id
          name
        }
        updatedAt
        updatedBy {
          id
          name
        }
      }
      operations {
        id
        name
        code
        amount
        tooth
        missing
        price
        diagnosis
        child
        status
        approved
        preAuth
        discountPercent
        insurancePercent
        allowMaxLimit
        discount
        details
        tax
        taxApplied
        initialDiscount
        approvalRequired
        insuranceDiscount
        insuranceValue
        insurance
        toothPart
        doctor {
          id
          name
          medicalNumber
        }
        branch {
          id
          name
          nphiesCode
        }
        dhsApproval {
          id
        }
      }
      users {
        id
        name
      }
      branch {
        id
        name
        address
        phones
        nphiesCode
      }
      doctor {
        id
        name
        dentalNotation
        medicalNumber
      }
      createAppointment {
        id
        start
        status
        room
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      eInvoiceStatus
      insuranceEInvoiceStatus
      lastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
      insuranceLastEInvoiceReport {
        id
        status
        submissionTime
        data {
          id
          qrCode
        }
      }
      eInvoiceSubmissions {
        id
        status
        attemptNumber
        submissionTime
        provider
        transactionType
        infoMessages
        warningMessages
        errorMessages
        createdAt
        awaitingResend
        invoiceRevisionId
        data {
          id
          uuid
          qrCode
          invoiceCounterValue
          complianceInvoiceType
          xmlContentS3Key
          signedXmlS3Key
          clearedXmlS3Key
          transactionType
        }
      }
      status
      cancelledAt
      cancelReason
      cancelledBy {
        id
        name
      }
      needsReReport
      revisions {
        id
        revisionNumber
        action
        reason
        wasReported
        snapshot
        createdAt
        createdBy {
          id
          name
        }
      }
      claimId
      claimLocked
      claim {
        id
        name
        status
        referenceId
      }
    }
  }
`

export const PAYMENT_DETAILS = gql`
  query PAYMENT_DETAILS($payment: ID!, $token: String) {
    paymentDetails(payment: $payment, token: $token) {
      id
      amount
      details
      createdAt
      type
      refunded
      claimed
      insuranceCompany {
        id
        name
      }
      doctor {
        id
        name
      }
      patientPointsTxs {
        id
        points
        expiresIn
      }
      signed
      signedAt
      signature
      invoice {
        id
        total
        paid
        paidInFull
        referenceId
        invoiceId
        patient {
          id
          firstName
          lastName
          patientId
          referenceId
          birthDate
          insuranceNumber
          title
        }
      }
    }
  }
`

export const PAYMENT_FULL_DETAILS = gql`
  query PAYMENT_FULL_DETAILS($payment: ID!) {
    paymentFullDetails(payment: $payment) {
      id
      type
      amount
      other
      balance
      claimed
      refunded
      details
      chart
      images
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      insuranceCompany {
        id
        name
      }
      patientPointsTxs {
        id
        points
        expiresIn
      }
      refPatientPointsTxs {
        id
        points
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      signed
      signedAt
      signature
      signedBy {
        id
        name
      }
      invoice {
        id
        total
        tax
        taxPercent
        balance
        discount
        discountPercent
        diagnosticFee
        insurance
        subtotal
        pendingPayment
        pendingPaymentPercent
        paid
        paidInFull
        details
        invoiceId
        referenceId
        balanceInvoice
        patient {
          id
          firstName
          lastName
          birthDate
          balance
          patientId
          referenceId
          phoneNumber
          title
          insuranceCompany {
            id
            name
          }
          insuranceLimit
          insurancePercentage
          insuranceEndDate
          insuranceUnlimited
          approvalRequired
          insured
        }
        branch {
          id
          name
        }
        doctor {
          id
          name
        }
        claim {
          id
          status
        }
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      refundedAt
      refundedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`
export const TOTAL_INVOICES = gql`
  query TOTAL_INVOICES(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $rangeDate: [DateTime!]!
    $pendingPayment: Boolean
    $showUpdatedInvoices: Boolean
    $filters: Filter
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalInvoices(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      rangeDate: $rangeDate
      pendingPayment: $pendingPayment
      showUpdatedInvoices: $showUpdatedInvoices
      filters: $filters
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`
export const PAYMENTS = gql`
  query PAYMENTS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    payments(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      type
      amount
      other
      balance
      claimed
      refunded
      details
      chart
      images
      tax
      insuranceCompany {
        id
        name
      }
      patientPointsTxs {
        id
        points
        expiresIn
      }
      refPatientPointsTxs {
        id
      }
      transaction {
        id
        treasury {
          id
          publicName
        }
      }
      signed
      signedAt
      signature
      signedBy {
        id
        name
      }
      invoice {
        id
        total
        tax
        taxPercent
        balance
        discount
        discountPercent
        diagnosticFee
        insurance
        subtotal
        pendingPayment
        pendingPaymentPercent
        paid
        paidInFull
        details
        invoiceId
        referenceId
        balanceInvoice
        eInvoiceStatus
        insuranceEInvoiceStatus
        lastEInvoiceReport {
          id
          status
          submissionTime
          data {
            id
            qrCode
          }
        }
        insuranceLastEInvoiceReport {
          id
          status
          submissionTime
          data {
            id
            qrCode
          }
        }
        patient {
          id
          firstName
          lastName
          birthDate
          balance
          patientId
          referenceId
          phoneNumber
          patientTags {
            id
            name
            color
            hasNextTags
          }
          firstPaymentDate
          nationalId
          title
          insuranceCompany {
            id
            name
          }
          insuranceLimit
          insurancePercentage
          insuranceEndDate
          referralDetails
          insuranceUnlimited
          approvalRequired
          insured
          createdAt
        }
        branch {
          id
          name
        }
        doctor {
          id
          name
        }
      }
      referralSource {
        id
        name
        color
      }
      referralSubSource {
        id
        name
        color
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      refundedAt
      refundedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export const DASHBOARD_PAYMENTS = gql`
  query DASHBOARD_PAYMENTS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    dashboardPayments(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      type
      amount
      other
      refunded
      details
      signed
      claimed
      invoice {
        id
        total
        tax
        taxPercent
        balance
        discount
        discountPercent
        diagnosticFee
        insurance
        subtotal
        pendingPayment
        pendingPaymentPercent
        paid
        paidInFull
        details
        invoiceId
        referenceId
        balanceInvoice
        patient {
          id
          firstName
          lastName
          birthDate
          patientId
          referenceId
          phoneNumber
          title
        }
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
`
export const TOTAL_PAYMENTS = gql`
  query TOTAL_PAYMENTS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
    $appointment: ID
    $searchTerm: String
    $forDashboard: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalPayments(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      appointment: $appointment
      searchTerm: $searchTerm
      forDashboard: $forDashboard
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`
export const INVOICES_INFO = gql`
  query INVOICES_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $appointment: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $searchTerm: String
    $filters: Filter
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    invoicesInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      appointment: $appointment
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      searchTerm: $searchTerm
      filters: $filters
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      balanceInvoice
      paid
      tax
      discount
      diagnosticFee
      pendingPayment
      total
      balance
      released
      insurance
    }
  }
`
export const PAYMENTS_INFO = gql`
  query PAYMENTS_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $appointment: ID
    $doctor: ID
    $searchTerm: String
    $filters: Filter
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    paymentsInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      appointment: $appointment
      doctor: $doctor
      searchTerm: $searchTerm
      filters: $filters
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      type
      claimed
      refunded
      _sum
      balance
    }
  }
`
export const EXPENSES_INFO = gql`
  query EXPENSES_INFO(
    $branchId: ID
    $userId: ID
    $supplier: ID
    $rangeDate: [DateTime!]!
    $assignedToId: ID
    $lab: ID
    $labItem: ID
    $searchTerm: String
    $filters: Filter
  ) {
    expensesInfo(
      branchId: $branchId
      userId: $userId
      supplier: $supplier
      rangeDate: $rangeDate
      assignedToId: $assignedToId
      lab: $lab
      labItem: $labItem
      searchTerm: $searchTerm
      filters: $filters
    ) {
      type
      amount
      paid
    }
  }
`
export const INCOMES_INFO = gql`
  query INCOMES_INFO(
    $branchId: ID
    $userId: ID
    $rangeDate: [DateTime!]!
    $assignedToId: ID
    $searchTerm: String
    $filters: Filter
  ) {
    incomesInfo(
      branchId: $branchId
      userId: $userId
      rangeDate: $rangeDate
      assignedToId: $assignedToId
      searchTerm: $searchTerm
      filters: $filters
    ) {
      type
      amount
    }
  }
`
export const OPERATIONS_INFO = gql`
  query OPERATIONS_INFO(
    $branchId: ID
    $doctor: ID
    $userId: ID
    $patient: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $appointment: ID
    $searchTerm: String
    $priceList: ID
    $chart: ChartTypes
    $procedure: ID
    $procedureGroup: ID
    $globalCondition: ID
    $forAppointmentUpdated: Boolean
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    operationsInfo(
      branchId: $branchId
      doctor: $doctor
      userId: $userId
      patient: $patient
      rangeDate: $rangeDate
      filters: $filters
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      appointment: $appointment
      searchTerm: $searchTerm
      priceList: $priceList
      chart: $chart
      procedure: $procedure
      procedureGroup: $procedureGroup
      globalCondition: $globalCondition
      forAppointmentUpdated: $forAppointmentUpdated
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      status
      _sum {
        total
        cost
        amount
        forOperator
        paid
        remaining
        remainingCost
      }
    }
  }
`

export const GET_PATIENT_OPERATIONS_FOR_QR = gql`
  query GET_PATIENT_OPERATIONS_FOR_QR($patient: ID!) {
    getPatientOperationsForQR(patient: $patient) {
      id
      firstName
      lastName
      birthDate
      patientId
      referenceId
      mixedDentition
      branch {
        id
        name
        phones
        address
        chartJsonForm
        company {
          id
          companyName
          companyLogo
          defaultLanguage
        }
      }
      history {
        id
        name
        code
        status
        child
        procedure {
          id
          name
          code
          toothEffect
        }
        condition {
          id
          name
          code
          toothEffect
        }
        tooth
        toothPart
      }
    }
  }
`

export const GET_PRESCRIPTION_DETAILS_FOR_QR = gql`
  query GET_PRESCRIPTION_DETAILS_FOR_QR($prescription: ID!) {
    getPrescriptionDetailsForQR(prescription: $prescription) {
      id
      details
      diagnosis
      advice
      followUpDate
      createdAt
      doctor {
        id
        name
      }
      branch {
        name
        address
        phones
        prescriptionJsonForm
        company {
          companyName
          companyLogo
          defaultLanguage
        }
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        birthDate
        nationalId
      }
      medication
    }
  }
`

export const GET_FORM_DETAILS_FOR_QR = gql`
  query GET_FORM_DETAILS_FOR_QR($formInstance: ID!) {
    getFormDetailsForQR(formInstance: $formInstance) {
      id
      name
      signed
      content
      createdAt
      signedAt
      signature
      signatureID
      signatureName
      witnessSign
      witnessID
      witnessName
      witnessSignAt
      freeForm {
        id
        jsonForm
      }
      doctor {
        id
        name
        dentalNotation
      }
      operations {
        id
        name
        code
        tooth
        child
      }
      branch {
        id
        name
        address
        phones
        freeFormJsonForm
        company {
          companyName
          companyLogo
          defaultLanguage
        }
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        birthDate
        nationalId
      }
    }
  }
`

export const GET_FREE_FORM_DETAILS_FOR_QR = gql`
  query GET_FREE_FORM_DETAILS_FOR_QR($form: ID!) {
    getFreeFormDetailsForQR(form: $form) {
      id
      name
      content
      jsonForm
      signRequired
      showOnline
      company {
        companyName
        companyLogo
        defaultLanguage
      }
    }
  }
`

export const GET_LAB_ORDER_DETAILS_FOR_QR = gql`
  query GET_LAB_ORDER_DETAILS_FOR_QR($labOrder: ID!) {
    getLabOrderDetailsForQR(labOrder: $labOrder) {
      id
      details
      tooth
      shade
      child
      name
      due
      paid
      received
      price
      items
      images
      user {
        id
        name
        dentalNotation
      }
      lab {
        id
        name
      }
      labItem {
        id
        images
      }
      expense {
        id
        paid
      }
      branch {
        id
        name
        phones
        address
        company {
          companyName
          companyLogo
          defaultLanguage
          currency
        }
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
      }
    }
  }
`

export const GET_INVOICE_DETAILS_FOR_QR = gql`
  query GET_INVOICE_DETAILS_FOR_QR($invoice: ID!) {
    getInvoiceDetailsForQR(invoice: $invoice) {
      id
      total
      tax
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      paid
      dfInsurance
      patientTaxPercent
      patientPart
      insuranceTaxPercent
      preAuth
      signature
      signed
      details
      paidInFull
      createdAt
      invoiceId
      dfTaxApplied
      referenceId
      dfDiscount
      dfTax
      doctor {
        id
        name
        dentalNotation
        medicalNumber
        chart
      }
      branch {
        id
        name
        address
        phones
        invoiceJsonForm
        company {
          id
          companyName
          currency
          companyLogo
          defaultLanguage
        }
      }
      payments {
        id
        claimed
        amount
        type
        refunded
        createdAt
      }
      operations {
        id
        name
        code
        amount
        status
        diagnosis
        tooth
        taxApplied
        price
        child
        discount
        tax
        insurance
      }
      insuranceCompany {
        id
        name
      }
      insurancePolicy {
        id
        holderName
        policyNumber
      }
      policyClass {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        birthDate
        insuranceNumber
        nationalId
        phoneNumber
        gender
        nationality
        country
        state
        area
      }
    }
  }
`

export const GET_PAYMENT_DETAILS_FOR_QR = gql`
  query GET_PAYMENT_DETAILS_FOR_QR($payment: ID!) {
    getPaymentDetailsForQR(payment: $payment) {
      id
      amount
      details
      createdAt
      type
      refunded
      claimed
      insuranceCompany {
        id
        name
      }
      doctor {
        id
        name
      }
      invoice {
        id
        total
        paid
        paidInFull
        referenceId
        invoiceId
        branch {
          id
          name
          address
          phones
          invoiceJsonForm
          company {
            id
            companyName
            currency
            companyLogo
            defaultLanguage
          }
        }
        patient {
          id
          firstName
          lastName
          patientId
          referenceId
          birthDate
          insuranceNumber
          nationalId
          points {
            id
            firstToExpire
            remaining
          }
        }
      }
    }
  }
`

export const GET_COMPANY_DETAILS = gql`
  query GET_COMPANY_DETAILS($loginName: String!) {
    getCompanyDetails(loginName: $loginName) {
      id
      currency
      companyName
      companyLogo
      defaultLanguage
      branches {
        id
        name
        phones
        address
        location
      }
      waConfig {
        id
        social
        contactEmail
        contactNumber
      }
    }
  }
`

export const GET_QUOTATION_DETAILS_FOR_QR = gql`
  query GET_QUOTATION_DETAILS_FOR_QR($quotation: ID!) {
    getQuotationDetailsForQR(quotation: $quotation) {
      id
      total
      tax
      taxPercent
      discount
      discountPercent
      diagnosticFee
      insurance
      subtotal
      pendingPayment
      operationInsurance
      pendingPaymentPercent
      createdAt
      diagnosis
      chart
      order
      hidePrices
      signature
      signed
      doctor {
        id
        name
        dentalNotation
        chart
      }
      branch {
        id
        name
        address
        phones
        invoiceJsonForm
        company {
          id
          companyName
          currency
          companyLogo
          defaultLanguage
        }
        invoiceJsonForm
      }
      procedures {
        id
        name
        code
        amount
        status
        tooth
        toothPart
        price
        child
        procedure {
          id
          toothEffect
        }
        condition {
          id
          toothEffect
        }
      }
      patient {
        id
        firstName
        lastName
        patientId
        referenceId
        birthDate
        insuranceNumber
        mixedDentition
        nationalId
        insuranceCompany {
          id
          name
        }
      }
    }
  }
`

export const ACTIVE_REMINDER_DETAILS = gql`
  query ACTIVE_REMINDER_DETAILS($reminderInstance: ID!) {
    activeReminderDetails(reminderInstance: $reminderInstance) {
      id
      createdAt
      date
      remindedAt
      name
      details
      at
      automatic
      types
      createdBy {
        id
        name
      }
      branch {
        id
        name
      }
      operation {
        id
        createdAt
        name
        code
      }
      operationStep {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        hasValidNumber
      }
      appointment {
        id
        start
        status
        room
      }
      reminder {
        id
        name
        automatic
        details
        info
        at
      }
    }
  }
`
export const QUOTATIONS = gql`
  query QUOTATIONS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $appointment: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    quotations(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      appointment: $appointment
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      total
      tax
      taxPercent
      patientTaxPercent
      insuranceTaxPercent
      discount
      discountPercent
      name
      chart
      diagnosis
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      details
      percentage
      operationInsurance
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        title
        insuranceNumber
        insuranceGroup
        insuranceCRT
        patientTags {
          id
          name
          color
          hasNextTags
        }
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
        insuranceCompany {
          id
          name
          taxPercent
        }
      }
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      appointment {
        id
        start
        status
        room
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const QUOTATIONS_FOR_PRINT = gql`
  query QUOTATIONS_FOR_PRINT(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $appointment: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    quotationsForPrint(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      appointment: $appointment
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      total
      tax
      taxPercent
      discount
      discountPercent
      name
      diagnosis
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      details
      percentage
      operationInsurance
      appointment {
        id
        start
        status
        room
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        insuranceNumber
        insuranceGroup
        insuranceCRT
        patientTags {
          id
          name
          color
          hasNextTags
        }
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
        insuranceCompany {
          id
          name
        }
      }
      operations {
        id
        name
        code
        price
        details
        amount
        tooth
        child
      }
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const TOTAL_QUOTATIONS = gql`
  query TOTAL_QUOTATIONS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $doctor: ID
    $insuranceCompanies: [ID]
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $appointment: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    totalQuotations(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      appointment: $appointment
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    )
  }
`
export const QUOTATION_DETAILS = gql`
  query QUOTATION_DETAILS($quotation: ID!, $token: String) {
    quotationDetails(quotation: $quotation, token: $token) {
      id
      total
      tax
      taxPercent
      patientTaxPercent
      insuranceTaxPercent
      discount
      discountPercent
      name
      chart
      insurance
      subtotal
      pendingPayment
      pendingPaymentPercent
      details
      diagnosis
      hidePrices
      percentage
      order
      operationInsurance
      appointment {
        id
        start
        status
        room
      }
      procedures {
        id
        name
        code
        amount
        tooth
        missing
        price
        child
        status
        approved
        details
        approvalRequired
        insuranceDiscount
        insuranceValue
        allowMaxLimit
        taxApplied
        toothPart
        invoiceId
        insuranceCompany {
          id
          name
        }
        procedure {
          id
          name
          code
          insuranceDiscount
          toothEffect
        }
        condition {
          id
          name
          code
          toothEffect
        }
        doctor {
          id
          name
        }
        dhsApproval {
          status
        }
      }
      users {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        birthDate
        balance
        patientId
        referenceId
        phoneNumber
        title
        insuranceNumber
        insuranceGroup
        insuranceCRT
        tax
        nationality
        nationalId
        identifierType
        referralSource {
          id
          name
          color
        }
        referralSubSource {
          id
          name
          color
        }
        mixedDentition
        insuranceCompany {
          id
          name
          taxPercent
        }
        policyClass {
          id
          name
          maxLimit
          insuranceLimit
          insuranceUnlimited
          insurancePercentage
        }
        insuranceLimit
        insurancePercentage
        insuranceEndDate
        insuranceUnlimited
        approvalRequired
        insured
      }
      branch {
        id
        name
      }
      doctor {
        id
        name
      }
      signed
      signature
      signedAt
      signedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const QUOTATIONS_INFO = gql`
  query QUOTATIONS_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $doctor: ID
    $insuranceCompanies: [ID]
    $searchTerm: String
    $filters: Filter
    $operation: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    quotationsInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $id
      rangeDate: $rangeDate
      doctor: $doctor
      insuranceCompanies: $insuranceCompanies
      searchTerm: $searchTerm
      filters: $filters
      operation: $operation
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      total
      tax
      discount
      percentage
    }
  }
`
export const PATIENT_LINKS = gql`
  query PATIENT_LINKS(
    $branchId: ID
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    patientLinks(
      branchId: $branchId
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    ) {
      id
      name
      phoneNumber
      limit
      expires
      registers
      hasMedical
      patientTag {
        id
        name
        color
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
      }
      priceList {
        id
        name
      }
      branch {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const PATIENT_LINK_DETAILS = gql`
  query PATIENT_LINKS($patientLink: ID!) {
    patientLinkDetails(patientLink: $patientLink) {
      id
      name
      phoneNumber
      limit
      expires
      registers
      hasMedical
      patient {
        id
        firstName
        lastName
        phoneNumber
      }
      patientTag {
        id
        name
        color
      }
      priceList {
        id
        name
      }
      branch {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const TOTAL_PATIENT_LINKS = gql`
  query TOTAL_PATIENT_LINKS($branchId: ID, $userId: ID, $rangeDate: [DateTime!]!, $filters: Filter, $searchTerm: String) {
    totalPatientLinks(branchId: $branchId, userId: $userId, rangeDate: $rangeDate, filters: $filters, searchTerm: $searchTerm)
  }
`
export const DUPLICATE_PATIENTS = gql`
  query DUPLICATE_PATIENTS(
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $searchTerm: String
    $disabled: Boolean
    $rangeDate: [DateTime!]!
    $insuranceCompanies: [ID]
    $insurancePolicy: ID
    $priceList: ID
    $branchId: ID
    $filters: Filter
    $doctor: ID
    $by: String!
    $policyClass: ID
    $patientTags: [ID]
    $referralSource: ID
    $referralSubSource: ID
  ) {
    duplicatePatients(
      orderBy: $orderBy
      branchId: $branchId
      skip: $skip
      take: $take
      searchTerm: $searchTerm
      disabled: $disabled
      rangeDate: $rangeDate
      insuranceCompanies: $insuranceCompanies
      insurancePolicy: $insurancePolicy
      priceList: $priceList
      filters: $filters
      doctor: $doctor
      by: $by
      policyClass: $policyClass
      patientTags: $patientTags
      referralSource: $referralSource
      referralSubSource: $referralSubSource
    ) {
      id
      fullName
      fullNumber
      patientId
      nationalId
      _count {
        fullName
        fullNumber
        patientId
        nationalId
      }
    }
  }
`
export const TOTAL_FREE_FORM_INSTANCES = gql`
  query TOTAL_FREE_FORM_INSTANCES(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $patient: ID
    $doctor: ID
    $appointment: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $operationStep: ID
  ) {
    totalFreeFormInstances(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $patient
      doctor: $doctor
      appointment: $appointment
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      operationStep: $operationStep
    )
  }
`

export const FREE_FORM_INSTANCES_INFO = gql`
  query FREE_FORM_INSTANCES_INFO(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $patient: ID
    $doctor: ID
    $appointment: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $operationStep: ID
  ) {
    freeFormInstancesInfo(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $patient
      doctor: $doctor
      appointment: $appointment
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      operationStep: $operationStep
    )
  }
`
export const FREE_FORM_INSTANCES = gql`
  query FREE_FORM_INSTANCES(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $patient: ID
    $doctor: ID
    $appointment: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $operation: ID
    $operationStep: ID
  ) {
    freeFormInstances(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      patient: $patient
      doctor: $doctor
      appointment: $appointment
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      operation: $operation
      operationStep: $operationStep
    ) {
      id
      name
      content
      signed
      signRequired
      signature
      signatureID
      signatureName
      witnessSign
      expiresIn
      witnessID
      witnessName
      witnessSignAt
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
        birthDate
        nationalId
      }
      appointment {
        id
        start
        end
        status
        room
      }
      branch {
        id
        name
      }
      freeForm {
        id
        name
        content
        jsonForm
      }
      users {
        id
        name
      }
      doctor {
        id
        name
      }
      signedAt
      signedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const FREE_FORM_INSTANCE_DETAILS = gql`
  query FREE_FORM_INSTANCE_DETAILS($formInstance: ID!, $token: String) {
    freeFormInstanceDetails(formInstance: $formInstance, token: $token) {
      id
      name
      content
      signed
      signRequired
      signature
      signatureID
      signatureName
      witnessSign
      expiresIn
      witnessID
      witnessName
      witnessSignAt
      freeForm {
        id
        name
        content
        jsonForm
      }
      patient {
        id
        firstName
        lastName
        phoneNumber
        title
        patientId
        referenceId
        birthDate
        nationalId
      }
      operations {
        id
        name
        code
        status
        child
        missing
        tooth
        createdAt
        doctor {
          id
          name
        }
      }
      operationSteps {
        id
        name
        doctor {
          id
          name
        }
        operation {
          id
          name
          code
          status
          child
          missing
          tooth
          createdAt
        }
      }
      appointment {
        id
        start
        end
        status
        room
      }
      branch {
        id
        name
      }
      users {
        id
        name
      }
      doctor {
        id
        name
      }
      signedAt
      signedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const PAYMENT_STEPS = gql`
  query PAYMENT_STEPS(
    $branchId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $doctor: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $payment: ID
    $procedure: ID
    $procedureGroup: ID
  ) {
    paymentSteps(
      branchId: $branchId
      orderBy: $orderBy
      skip: $skip
      take: $take
      doctor: $doctor
      rangeDate: $rangeDate
      filters: $filters
      payment: $payment
      procedure: $procedure
      procedureGroup: $procedureGroup
    ) {
      id
      amount
      tax
      type
      room
      chart
      discount
      refunded
      forOperator
      payment {
        id
        type
        other
        claimed
        claimedAt
        invoice {
          id
          patient {
            id
            fullName
            firstName
            lastName
            birthDate
            patientId
            referenceId
            phoneNumber
            createdAt
            nationalId
            referralDetails
            referralSource {
              id
              name
            }
            referralSubSource {
              id
              name
            }
          }
        }
      }
      salaryAdjustment {
        id
      }
      operationStep {
        id
        name
      }
      operation {
        id
        name
      }
      procedure {
        id
        name
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      createdAt
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`
export const TOTAL_PAYMENT_STEPS = gql`
  query TOTAL_PAYMENT_STEPS(
    $branchId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $doctor: ID
    $payment: ID
    $procedure: ID
    $procedureGroup: ID
  ) {
    totalPaymentSteps(
      branchId: $branchId
      rangeDate: $rangeDate
      filters: $filters
      doctor: $doctor
      payment: $payment
      procedure: $procedure
      procedureGroup: $procedureGroup
    )
  }
`

export const PAYMENT_STEP_DETAILS = gql`
  query OPERATION_STEP_DETAILS($paymentStep: ID!) {
    paymentStepDetails(paymentStep: $paymentStep) {
      id
      amount
      tax
      chart
      discount
      refunded
      type
      room
      forOperator
      payment {
        id
        type
        claimed
        claimedAt
        invoice {
          id
          patient {
            id
            fullName
          }
        }
      }
      salaryAdjustment {
        id
      }
      operationStep {
        id
        name
      }
      operation {
        id
        name
      }
      procedure {
        id
        name
      }
      doctor {
        id
        name
      }
      branch {
        id
        name
      }
      createdAt
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const PAYMENT_STEPS_INFO = gql`
  query OPERATION_STEPS_INFO(
    $branchId: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $doctor: ID
    $payment: ID
    $procedure: ID
    $procedureGroup: ID
  ) {
    paymentStepsInfo(
      branchId: $branchId
      rangeDate: $rangeDate
      filters: $filters
      doctor: $doctor
      payment: $payment
      procedure: $procedure
      procedureGroup: $procedureGroup
    ) {
      amount
      tax
      discount
      forOperator
      refunded
    }
  }
`

export const GET_PATIENT_UNSIGNED_FORMS = gql`
  query GET_PATIENT_UNSIGNED_FORMS($patient: ID!) {
    getPatientUnsignedForms(patient: $patient) {
      id
      name
      content
      jsonForm
    }
  }
`

export const GET_TENANT_SPACE_QUERY = gql`
  query GET_TENANT_SPACE_QUERY($input: PatientTenantSpaceInput!) {
    patientApp {
      tenantSpace(input: $input) {
        data {
          tenant {
            branding {
              brandingColor
            }
          }
        }
      }
    }
  }
`

export const DHS_APPROVALS = gql`
  query DHS_APPROVALS(
    $patientId: String
    $patient: ID
    $orderBy: String
    $skip: Int
    $take: Int
    $rangeDate: [DateTime!]
    $filters: Filter
    $searchTerm: String
  ) {
    getDHSApprovals(
      input: {
        patientId: $patientId
        patient: $patient
        orderBy: $orderBy
        skip: $skip
        take: $take
        rangeDate: $rangeDate
        filters: $filters
        searchTerm: $searchTerm
      }
    ) {
      success
      message
      data {
        id
        approvalNumber
        status
        responseDate
        manualUpdatedBy {
          id
          name
        }
        canceledAt
        canceledBy {
          id
          name
        }
        createdAt
        updatedAt
        operations {
          id
          name
          invoiceId
        }
        patient {
          id
          firstName
          lastName
          branch {
            id
            nphiesCode
          }
          insuranceCompany {
            id
            nphiesCode
          }
        }
      }
    }
  }
`

export const TOTAL_DHS_APPROVALS = gql`
  query TOTAL_DHS_APPROVALS($patientId: String, $patient: ID, $rangeDate: [DateTime!], $filters: Filter, $searchTerm: String) {
    totalDHSApprovals(
      input: { patientId: $patientId, patient: $patient, rangeDate: $rangeDate, filters: $filters, searchTerm: $searchTerm }
    )
  }
`

export const DHS_APPROVALS_INFO_QUERY = gql`
  query dhsApprovalsInfo($rangeDate: [DateTime!], $filters: Filter, $searchTerm: String, $patient: ID) {
    totalDHSApprovals(input: { rangeDate: $rangeDate, filters: $filters, searchTerm: $searchTerm, patient: $patient })
    approvedCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["APPROVED"] }, searchTerm: $searchTerm, patient: $patient }
    )
    partiallyApprovedCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["PARTIALLY_APPROVED"] }, searchTerm: $searchTerm, patient: $patient }
    )
    rejectedCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["REJECTED", "DENIED"] }, searchTerm: $searchTerm, patient: $patient }
    )
    errorCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["ERROR"] }, searchTerm: $searchTerm, patient: $patient }
    )
    pendingCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["PENDING", "DRAFT"] }, searchTerm: $searchTerm, patient: $patient }
    )
    canceledCount: totalDHSApprovals(
      input: { rangeDate: $rangeDate, filters: { status: ["CANCELED"] }, searchTerm: $searchTerm, patient: $patient }
    )
  }
`
